module.exports = __webpack_public_path__ + "img/ahk_SL.f8498627.svg";